import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c84cc57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_3 = {
  key: 0,
  class: "carousel_header"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhuma trilha obrigatória para exibir.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_FilterSelect = _resolveComponent("FilterSelect")!
  const _component_IntroductoryContentModal = _resolveComponent("IntroductoryContentModal")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!
  const _component_CommentsModal = _resolveComponent("CommentsModal")!
  const _component_CourseTrackItem = _resolveComponent("CourseTrackItem")!
  const _component_course = _resolveComponent("course")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Search, {
        onSearching: _ctx.searchTrack,
        "search-bar-text": "Pesquisar trilha...",
        height: '24px',
        fontSize: '15px',
        id: "search-courses"
      }, null, 8, ["onSearching"]),
      _createVNode(_component_FilterSelect, {
        modelValue: _ctx.selectedFilter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFilter) = $event)),
        options: [
        { value: '0', label: 'Todos' },
        { value: '1', label: 'Trilha em andamento' },
        { value: '2', label: 'Trilha finalizada' }
      ],
        id: "filter_by",
        label: "Filtrar por:",
        onChange: _ctx.sortTrainingTypes
      }, null, 8, ["modelValue", "onChange"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.openModalIntroductoryContent && _ctx.introductoryContent)
        ? (_openBlock(), _createBlock(_component_IntroductoryContentModal, {
            key: 0,
            onClose: _ctx.closeModalIntroductoryContent,
            "introductory-content": _ctx.introductoryContent
          }, null, 8, ["onClose", "introductory-content"]))
        : _createCommentVNode("", true),
      (_ctx.isCommentsModalOpen)
        ? (_openBlock(), _createBlock(_component_CommentsModal, {
            key: 1,
            onCloseCommentsModal: _ctx.closeCommentsModal,
            title: _ctx.commentModalTitle
          }, {
            default: _withCtx(() => [
              (_ctx.comments.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comments, (comment, index) => {
                    return (_openBlock(), _createBlock(_component_Comment, {
                      key: index,
                      "user-name": comment.userName,
                      comment: comment.message,
                      date: _ctx.toLocaleDateTime(comment.createAt),
                      stars: comment.rating,
                      "user-image": comment.userImage,
                      "content-name": comment.contentName
                    }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                  }), 128))
                : (_openBlock(), _createBlock(_component_ContentFallback, { key: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }, 8, ["onCloseCommentsModal", "title"]))
        : _createCommentVNode("", true),
      (
        _ctx.mandatoryCourseTrack.some(
          courseTrack =>
            courseTrack.title
              .toLowerCase()
              .includes(_ctx.searchCourseTrack.toLowerCase()) &&
            (_ctx.selectedFilter === '0' ||
              (_ctx.selectedFilter === '1' && !courseTrack.finished) ||
              (_ctx.selectedFilter === '2' && courseTrack.finished))
        )
      )
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.mandatoryCourseTrack, (courseTrack) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: courseTrack.id,
              class: "trainings_track"
            }, [
              _createVNode(_component_CourseTrackItem, {
                onClick: ($event: any) => (_ctx.toggleTrack(courseTrack.id)),
                activeCourseTrackID: _ctx.activeCourseTrackID,
                courseTrack: courseTrack
              }, null, 8, ["onClick", "activeCourseTrackID", "courseTrack"]),
              (
            _ctx.activeCourseTrackID === courseTrack.id &&
              _ctx.mandatoryCourseTrackTrainings.course.length
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_Carousel, {
                      settings: _ctx.recommendedSettings,
                      breakpoints: _ctx.recommendedBreakpoints,
                      "onUpdate:modelValue": ($event: any) => (_ctx.handleSlide(courseTrack.id))
                    }, {
                      addons: _withCtx(() => [
                        _createVNode(_component_Navigation)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mandatoryCourseTrackTrainings.course, (training) => {
                          return (_openBlock(), _createBlock(_component_Slide, {
                            key: training.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_course, {
                                course: training,
                                blocked: training.isBlocked,
                                onOpenCourse: ($event: any) => (_ctx.goToCourse(training)),
                                onLoadCourseCommentsModal: ($event: any) => (_ctx.loadCourseCommentsModal(training)),
                                onOpenIntroductoryContent: ($event: any) => (_ctx.openIntroductoryContent(training)),
                                progress: training.progress
                              }, null, 8, ["course", "blocked", "onOpenCourse", "onLoadCourseCommentsModal", "onOpenIntroductoryContent", "progress"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["settings", "breakpoints", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, 
          courseTrack.title
            .toLowerCase()
            .includes(_ctx.searchCourseTrack.toLowerCase())
        ]
            ])
          }), 128))
        : (_openBlock(), _createBlock(_component_ContentFallback, { key: 3 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
    ])
  ], 64))
}